/**
 * Capacitor — two parallel lines (non-polarised). Polarised electrolytic
 * variant (curved second plate + plus marker) deferred until `Component`
 * exposes a polarisation flag.
 */
import { useTheme } from "@mui/material";
import type { NodeProps } from "@xyflow/react";

import { SymbolFrame } from "./SymbolFrame";
import { SYMBOL_STROKE_WIDTH, symbolColors } from "./symbolStyle";

interface CapacitorData {
  refdes?: string;
  value?: string | null;
  highlight?: boolean;
}

export function CapacitorNode({ data, width, height }: NodeProps) {
  const t = useTheme();
  const { stroke } = symbolColors(t);
  const d = data as CapacitorData;
  return (
    <SymbolFrame
      refdes={d.refdes}
      value={d.value}
      width={width}
      height={height}
      highlight={d.highlight}
    >
      <svg
        viewBox="0 0 56 24"
        width="56"
        height="20"
        fill="none"
        stroke={stroke}
        strokeWidth={SYMBOL_STROKE_WIDTH}
        strokeLinecap="round"
      >
        <line x1="0" y1="12" x2="24" y2="12" />
        <line x1="24" y1="2" x2="24" y2="22" />
        <line x1="32" y1="2" x2="32" y2="22" />
        <line x1="32" y1="12" x2="56" y2="12" />
      </svg>
    </SymbolFrame>
  );
}
